export const getWorkspaceMenuState = (state) => state.system.workspaceMenu;
